import type { SessionTokenData } from '@shared/services';
import { jwtDecode } from 'jwt-decode';

export function decodeAccessToken(accessToken: string): SessionTokenData {
  try {
    return jwtDecode<SessionTokenData>(accessToken);
  } catch {
    throw new Error('Invalid access token');
  }
}
